<template>
  <!-- 显示开通vip -->
  <van-overlay :show="showOpenVip" @click="showOpenVip = false" :z-index="zIndex">

    <div class="open-vip-wrap" v-if="styleName === 's1'">
      <div class="open-vip">
        <p>仅支持VIP查看</p>
        <p>{{ openVipTextShow }}</p>
        <button @click="toOpenMember()">开通VIP会员</button>
      </div>
      <button type="button" class="open-vip-close-btn" @click="showOpenVip = false">
        <img src="@/assets/icon-97.png" alt="">
      </button>
    </div>

    <div class="open-vip-s2" v-if="styleName === 's2'">
      <p>{{ openVipTextShow }}</p>
      <button @click="$router.push('/member')">立即开通</button>
      <button class="cancel-btn" @click="showOpenVip = false">取消</button>
    </div>

  </van-overlay>
</template>

<script>

import {UserCenterService} from '@/common/service';
import {Dialog} from 'vant';

export default {
  name: 'is-login-vip',
  props: {
    // none 无需登录，无需VIP login 必须登录 vip 必须VIP
    type: {
      default: 'none',
    },
    styleType: {
      default: 's1',
    },
    // 登录提示内容
    toLoginText: {
      default: 'VIP内容请登录后查看',
    },
    // 开通vip提示内容
    openVipText: {
      default: '开通VIP查看本内容',
    },
    zIndex: {
      default: '99999'
    },
  },
  data() {
    return {
      // 显示开通vip
      showOpenVip: false,
      // 当前登录用户信息
      userInfo: {},
      // 是否登录
      isLogin: false,
      // 是否是vip
      isVip: false,

      styleName: 's1',
      openVipTextShow: '',
      toLoginTextShow: '',
    };
  },
  mounted() {
    this.styleName = this.styleType;
    this.openVipTextShow = this.openVipText;
    this.toLoginTextShow = this.toLoginText;
    if (this.type !== 'none') {
      this.getUserInfo();
    }
  },
  methods: {
    show(msg = '', type = 'login', style = 's1') {
      this.styleName = style;
      if (type === 'login') {
        this.toLoginTextShow = msg || 'VIP内容请登录后查看';
        Dialog.confirm({
          message: this.toLoginTextShow,
          confirmButtonText: '去登录'
        }).then(() => {
          this.$router.push('/login');
        });
      } else if (type === 'vip') {
        this.openVipTextShow = msg || '开通VIP查看本内容';
        this.showOpenVip = true;
      }
    },

    /**
     * 判断是否执行下一步
     * @param isVip
     * @param fn
     */
    next(isVip = true, fn = () => {}) {
      if (this.type === 'none' || !isVip) return fn();
      // 必须登录
      if (this.type === 'login' && this.isLoginFn()) return fn();
      // 登录且必须是vip
      if (this.type === 'vip' && this.isLoginFn() && this.isVipFn()) return fn();
    },

    isLoginFn() {
      if (!this.isLogin) {
        this.show(this.toLoginTextShow, 'login', this.style);
      }
      return this.isLogin;
    },

    isVipFn() {
      if (!this.isVip) {
        this.show(this.openVipTextShow, 'vip', this.style);
      }
      return this.isVip;
    },

    // 开通会员
    toOpenMember() {
      this.showOpenVip = false;
      this.$router.push('/member');
    },
    // 获取用户信息
    getUserInfo() {
      UserCenterService.getUserInfo(null, true).then(({ data }) => {
        this.userInfo = data.detail || {};
        this.isLogin = true;
        const userLevel = data.user_level;
        if (userLevel && userLevel.id > 0) {
          const currentTime = new Date().getTime();
          const endTime = new Date(userLevel.end_date.replace(/-/g, '/')).getTime();
          this.isVip = currentTime < endTime;
        }
      });
      // console.log('判断VIP里面获取的用户数据')
    },
  },
}
</script>

<style scoped>
.open-vip-wrap {
  width: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.open-vip-close-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0 0;

}

.open-vip-close-btn > img {
  width: 36px;
}
.open-vip {
  width: calc(100% - 120px);
  height: 190px;
  background: #FFFFFF;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}

.open-vip p {
  font-size: 16px;
  font-weight:bold;
  color: #222222;
  line-height: 35px;
}

.open-vip button {
  width: 165px;
  height: 42px;
  background: #EBD793;
  border-radius: 50px;
  font-size: 15px;
  font-weight: bold;
  color: #553D0E;
  margin-top: 30px;
}

.open-vip-s2 {
  width: calc(100% - 110px);
  background: #FFFFFF;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  position: fixed;
  top: 50%;
  left: 50%;
  padding: 42px 0 14px;
}

.open-vip-s2 p {
  font-size: 16px;
  font-weight: bold;
  color: #222222;
  line-height: 35px;
  margin-bottom: 35px;
}

.open-vip-s2 button {
  width: 135px;
  height: 42px;
  background: #EBD793;
  border-radius: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #553D0E;
}

.open-vip-s2 button.cancel-btn {
  color: #666666;
  margin-top: 4px;
  background: initial;
  font-weight: normal;
}
</style>
